/* */
 
 

import { takeEvery, put, takeLatest, delay, select, race, take, call } from 'redux-saga/effects';
import Querystring from 'query-string';
import {
  isResponseSuccess,
  stringifyListPhone,
  convertListToParamString,
  bytesToMegaBytes,
  getNextDataRefetch,
  isProcessingImportFile,
} from 'helpers';
import types from 'redux/types';
import Services from 'services';
import {
  MANAGE_CONTACTS_SERVLET_URL,
  GET_LANDLINE_CHECK_STATUS_URL,
  START_LINE_CHECK_URL,
  CANCEL_LANDLINE_URL,
  IMPORT_CONTACT_URL,
  GET_ALL_RUNNING_CONTACT_IMPORT_URL,
  IMPORT_FILE_STATUS_URL,
  UPLOAD_CONTACT_URL,
  PREVIEW_LINE_URL,
  DELETE_PREVIEW_FILE_URL,
  IMPORT_FROM_STORAGE_URL,
  CANCEL_IMPORT_URL,
  SPLIT_GROUP_URL,
} from 'consts/api';
import hooks from 'hooks';
import {
  TIME_OUT_CLOSE_TOAST,
  MAXIMUM_SIZE_UPLOAD,
  actionTypeManageContact,
  ContactFieldsShouldHided,
} from 'consts/data';
import { filterContactDetailInitial, ITEM_PER_PAGE } from 'consts/filters';
import ManageContactServices from 'services/ManageContactServices';
import { showError } from 'helpers/handleError';
import { notifySuccess } from 'helpers/handleNotification';
import ContactServices from 'services/ContactServices';
import i18n from 'i18n';
import components, { typeMounted, typeUnmounted } from 'consts/components';
import { messageLockContactRunning } from 'consts/message';
import { chunk, isString, isObject } from 'lodash';
import { handleWorker } from 'helpers/saga';
import ContactGroupModel from 'models/contact-group.model';
import { parseTargetForSearchContact } from 'helpers/target';

const {
  REQUEST_LOAD_MORE_CONTACT,
  REQUEST_LOAD_MORE_CONTACT_FAILED,
  REQUEST_LOAD_MORE_CONTACT_SUCCESS,
  REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_MANAGE_CONTACT_SERVLET,
  REQUEST_API_CONTACT_SERVLET,
  REQUEST_API_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_CONTACT_SERVLET_FAILED,
  REQUEST_CLEAR_CONTACT_SERVLET,
  REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_GET_CONTACT_BELONG_TO,
  REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS,
  REQUEST_ADD_CONTACT,
  REQUEST_ADD_CONTACT_FAILED,
  REQUEST_ADD_CONTACT_SUCCESS,
  REQUEST_REMOVE_CONTACT,
  REQUEST_REMOVE_CONTACT_SUCCESS,
  REQUEST_REMOVE_CONTACT_FAILED,
  REQUEST_GET_EDIT_CONTACT,
  REQUEST_GET_EDIT_CONTACT_SUCCESS,
  REQUEST_GET_EDIT_CONTACT_FAILED,
  REQUEST_SCRUB_CONTACT,
  REQUEST_SCRUB_CONTACT_SUCCESS,
  REQUEST_SCRUB_CONTACT_FAILED,
  // REQUEST_GETALL_LANDLINE_CHECK,
  // REQUEST_GETALL_LANDLINE_CHECK_FAILED,
  // REQUEST_GETALL_LANDLINE_CHECK_SUCCESS,
  // REQUEST_CHECK_SCRUB_SUCCESS,
  REQUEST_CHECK_SCRUB,
  REQUEST_CANCEL_IMPORT,
  REQUEST_CANCEL_IMPORT_SUCCESS,
  REQUEST_CANCEL_IMPORT_FAILED,
  // REQUEST_CHECK_CANCELLED_STATUS_IMPORT,
  REQUEST_REMOVE_GROUP,
  REQUEST_REMOVE_GROUP_SUCCESS,
  REQUEST_REMOVE_GROUP_FAILED,
  REQUEST_CANCEL_LANDLINE,
  REQUEST_CANCEL_LANDLINE_FAILED,
  REQUEST_CANCEL_LANDLINE_SUCCESS,
  REQUEST_IMPORT_LIST_CONTACT,
  REQUEST_IMPORT_LIST_CONTACT_SUCCESS,
  REQUEST_IMPORT_LIST_CONTACT_FAILED,
  REQUEST_CHECK_STATUS_IMPORT,
  REQUEST_CHECK_STATUS_IMPORT_SUCCESS,
  REQUEST_CHECK_STATUS_IMPORT_FAILED,
  REQUEST_GET_PROCESS_ID_IMPORT,
  REQUEST_GET_PROCESS_ID_IMPORT_FAILED,
  REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS,
  REQUEST_DELETE_CONTACT_BY_CARRIER,
  REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED,
  REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS,
  REQUEST_UPLOAD_LIST_CONTACT,
  REQUEST_UPLOAD_LIST_CONTACT_FAILED,
  REQUEST_UPLOAD_LIST_CONTACT_SUCCESS,
  REQUEST_GET_PREVIEW_LINE,
  REQUEST_GET_PREVIEW_LINE_FAILED,
  REQUEST_GET_PREVIEW_LINE_SUCCESS,
  REQUEST_HEADER_FIELD,
  REQUEST_HEADER_FIELD_SUCCESS,
  REQUEST_HEADER_FIELD_FAILED,
  REQUEST_DELETE_FILE,
  REQUEST_DELETE_FILE_SUCCESS,
  REQUEST_DELETE_FILE_FAILED,
  REQUEST_IMPORT_FROM_STORAGE,
  REQUEST_IMPORT_FROM_STORAGE_FAILED,
  REQUEST_IMPORT_FROM_STORAGE_SUCCESS,
  REQUEST_MERGE_GROUPS,
  REQUEST_MERGE_GROUPS_FAILED,
  REQUEST_MERGE_GROUPS_SUCCESS,
  REQUEST_SPLIT_GROUPS,
  REQUEST_SPLIT_GROUPS_FAILED,
  REQUEST_SPLIT_GROUPS_SUCCESS,
  REQUEST_SEARCH_CONTACT_SERVLET,
  REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS,
  REQUEST_SEARCH_CONTACT_SERVLET_FAILED,
  REQUEST_CHANGE_NAME_CONTACT,
  REQUEST_CHANGE_NAME_CONTACT_SUCCESS,
  REQUEST_CHANGE_NAME_CONTACT_FAILED,
  REQUEST_GET_DATA_CONSUMING,
  REQUEST_GET_DATA_CONSUMING_SUCCESS,
  REQUEST_GET_DATA_CONSUMING_FAILED,
  REQUEST_START_DATA_CONSUMING,
  REQUEST_START_DATA_CONSUMING_SUCCESS,
  REQUEST_START_DATA_CONSUMING_FAILED,
  REQUEST_GET_DATA_REFRESHING,
  REQUEST_GET_DATA_REFRESHING_SUCCESS,
  REQUEST_GET_DATA_REFRESHING_FAILED,
  REQUEST_START_DATA_REFRESHING,
  REQUEST_START_DATA_REFRESHING_SUCCESS,
  REQUEST_START_DATA_REFRESHING_FAILED,
  REQUEST_CHECK_SCRUB_CANCEL,
  REQUEST_SET_LEAD_CALLBACK_LINK,
  REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS,
  REQUEST_SET_LEAD_CALLBACK_LINK_FAILED,
} = types;

const { Notification } = hooks;

const checkIsLastContact = (listContact = []) => {
  return listContact.length < 20;
};

const checkIsContactInProcessing = (message = '') => {
  return new RegExp(messageLockContactRunning.toLowerCase(), 'g').test(message.toLowerCase());
};

function* recheckStatusImportingScrubbing({ groupId = '' }) {
  yield getContactServlet({ groupId, ...filterContactDetailInitial });
}

//! Main Function
function* refetchData({ isSendPage, typeContact, filters }) {
  const { page } = filters;
  const action = isSendPage
    ? actionTypeManageContact.searchDeviceGroups
    : actionTypeManageContact.getDeviceGroups;
  try {
    let listRequest = [];
    const currentNumberPage = page + 1;
    for (let i = 0; i < currentNumberPage; i++) {
      const bodyResponseManageContact = isSendPage
        ? { action }
        : {
            action,
            ...ContactGroupModel.initialFilters({ ...filters, page: i }),
          };
      listRequest = [
        ...listRequest,
        ContactServices.getManageContact({
          type: typeContact,
          body: bodyResponseManageContact,
        }),
      ];
    }

    const { res, cancelled } = yield race({
      res: Promise.all(listRequest),
      cancelled: take([REQUEST_API_MANAGE_CONTACT_SERVLET]),
    });
    if (cancelled) {
      alert('true');
      return;
    }

    const [nextData, isLast] = getNextDataRefetch(res);
    yield put({
      type: REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
      typeContact,
      data: nextData,
      action,
      isLast,
    });
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_API_CONTACT_SERVLET_FAILED, error });
  }
}

function* getContactBelongTo(data) {
  data.action = 'getContactBelongTo';
  const { sessionId, phone, action } = data;
  const body = Querystring.stringify({
    action,
    phone,
    sessionId,
  });
  try {
    const res = yield Services.post(MANAGE_CONTACTS_SERVLET_URL, body);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        yield put({
          type: REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS,
          data: res.data.split(','),
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_API_CONTACT_SERVLET_FAILED, error });
  }
}

function* getManageContactServlet({ isSendPage, typeContact, filters = {}, callbacks }) {
  const { name = '', size = ITEM_PER_PAGE, page, country } = filters;
  const action = isSendPage
    ? actionTypeManageContact.searchDeviceGroups
    : actionTypeManageContact.getDeviceGroups;

  try {
    const bodyResponseManageContact = isSendPage
      ? { action }
      : {
          action,
          name,
          size,
          page,
          country,
        };

    const responseManage = yield ContactServices.getManageContact({
      type: typeContact,
      body: bodyResponseManageContact,
    });
    if (isResponseSuccess(responseManage.status) && typeof responseManage.data !== 'string') {
      const isLast = checkIsLastContact(responseManage?.data);
      yield put({
        type: REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
        typeContact,
        data: responseManage.data,
        action,
        isLast,
      });
      callbacks && callbacks.onSuccess();

      // const isImportingOrScrubbing = (responseManage?.data || []).some(el => el.isScrubbing || el.isImporting);
      // if (!isSendPage && isImportingOrScrubbing) {
      // 	yield getManageContactServlet({ isSendPage, typeContact, filters, callbacks });
      // }
      // return;
    }

    if (responseManage?.data === 'FAIL') {
      showError(i18n.t('contact:error_get_contact'));
      callbacks && callbacks.onFailed(i18n.t('contact:error_get_contact'));
      yield put({
        type: REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
        typeContact,
        data: [],
        action,
        isLast: true,
      });
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_API_CONTACT_SERVLET_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

function* loadMoreManageContactServlet({ typeContact, filters = {}, callbacks }) {
  const { name = '', size = ITEM_PER_PAGE, page, country } = filters;
  try {
    const bodyResponseManageContact = {
      action: 'getDeviceGroups',
      name,
      size,
      page,
      country,
    };

    const responseManage = yield ContactServices.getManageContact({
      type: typeContact,
      body: bodyResponseManageContact,
    });
    if (isResponseSuccess(responseManage.status) && typeof responseManage.data !== 'string') {
      const isLast = checkIsLastContact(responseManage?.data);
      yield put({
        type: REQUEST_LOAD_MORE_CONTACT_SUCCESS,
        typeContact,
        data: responseManage.data,
        isLast,
      });
      callbacks && callbacks.onSuccess();

      yield put({
        type: types.REQUEST_CHECK_SCRUBBING,
        typeContact,
        data: responseManage.data,
      });
      yield put({
        type: types.REQUEST_CHECK_IMPORTING,
        typeContact,
        data: responseManage.data,
      });
      return;
    }
    if (responseManage?.data === 'FAIL') {
      showError(i18n.t('contact:error_get_contact'));
      callbacks && callbacks.onFailed(i18n.t('contact:error_get_contact'));
      yield put({
        type: REQUEST_LOAD_MORE_CONTACT_SUCCESS,
        typeContact,
        data: [],
      });
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_LOAD_MORE_CONTACT_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

function* getContactServlet(data) {
  const {
    groupId,
    pageSize,
    pageIndex,
    searchValue,
    sortFields: sortField,
    sortDirections: direction,
    phoneType,
    target,
  } = data;
  const page = pageIndex + 1;

  try {
    const responseTotal = yield ManageContactServices.totalContactV2({
      groupId,
      target: parseTargetForSearchContact(target || []),
    });
    const { responseSearch, cancelled } = yield race({
      responseSearch: ManageContactServices.searchContactV2({
        groupId,
        pageSize,
        page,
        index: pageSize,
        sortField,
        direction: direction.toLowerCase(),
        searchValue,
        searchTagDtos: parseTargetForSearchContact(target || []),
      }),
      cancelled: take(typeUnmounted(components.contactDetail)),
    });

    if (cancelled) {
      return;
    }

    if (isResponseSuccess(responseTotal.status) && isResponseSuccess(responseSearch.status)) {
      if (
        typeof responseSearch.data === 'object' &&
        typeof responseTotal.data === 'number' &&
        responseSearch.data.code &&
        responseSearch.data.code == 200
      ) {
        yield put({
          type: REQUEST_API_CONTACT_SERVLET_SUCCESS,
          contacts: ContactGroupModel.mappingDataMapInListContacts(responseSearch.data.contacts),
          total: responseTotal.data,
          infoContact: {
            ...(responseSearch?.data || {}),
            groupId,
            groupName: responseSearch.data.name,
            dialogId: responseSearch?.data?.dialogId,

            optout: responseSearch?.data?.optout,
            sent: responseSearch?.data?.sent,
            triggered: responseSearch?.data?.triggered,
            type: responseSearch?.data?.type,
            delivered: responseSearch?.data?.delivered,
            failed: responseSearch?.data?.failed,
            blocked: responseSearch?.data?.blocked,
            clicked: responseSearch?.data?.clicked,
            metadata: responseSearch?.data?.metadata || {},
            originalId: responseSearch?.data?.originalId || null,
          },
          groupId,
        });
      } else {
        showError(i18n.t('contact:group_contact_existed'));
        yield put({
          type: REQUEST_API_CONTACT_SERVLET_FAILED,
          error: i18n.t('contact:group_contact_existed'),
        });
      }
    } else {
      yield put({
        type: REQUEST_API_CONTACT_SERVLET_FAILED,
        error: i18n.t('contact:fail_filter_contact'),
      });
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_API_CONTACT_SERVLET_FAILED, error });
  }
}

function* removeContact(data) {
  data.action = 'removeContacts';
  const {
    action,
    groupId,
    selectedRow,
    removeFromThisGroup,
    removeFromAllGroups,
    searchValue,
    uncheckNumbers,
    setSubmitting,
    isSelectAll,
    toggle,
    callbacks,
  } = data;
  try {
    setSubmitting(true);
    const chunkArray = chunk(selectedRow, 200);
    const listRequest = chunkArray.map((eachSelectedRow) => {
      const body = isSelectAll
        ? Querystring.stringify({
            action,
            groupId,
            deviceId: '',
            phones: stringifyListPhone(eachSelectedRow),
            removeFromThisGroup,
            removeFromAllGroups,
            everythingSelected: isSelectAll,
            searchValue,
            uncheckNumbers,
          })
        : Querystring.stringify({
            action,
            phones: stringifyListPhone(eachSelectedRow),
            groupId,
            removeFromThisGroup,
            removeFromAllGroups,
            searchValue,
            uncheckNumbers,
            deviceId: '',
          });
      return Services.post(MANAGE_CONTACTS_SERVLET_URL, body);
    });

    const res = yield Promise.allSettled(listRequest);
    const allSuccess = res.every(
      (el) => el.status === 'fulfilled' && el?.value?.data === 'SUCCESS'
    );

    if (allSuccess) {
      yield put({
        type: REQUEST_REMOVE_CONTACT_SUCCESS,
        payload: { phoneSelected: selectedRow, isSelectAll },
      });
      yield callbacks && callbacks.onSuccess();
      notifySuccess(i18n.t('contact:remove_contact_successfully'));
    } else {
      const itemErrorFound = res.find(
        (el) => el.status === 'fulfilled' && el?.value?.data !== 'SUCCESS'
      );
      if (itemErrorFound && isObject(itemErrorFound)) {
        const message = itemErrorFound?.value?.data || '';
        showError(message);
        yield put({ type: REQUEST_REMOVE_CONTACT_FAILED, error: message });
      }
    }

    setSubmitting(false);
    toggle();
  } catch (error) {
    showError(error);
    setSubmitting(false);
    toggle();
    yield put({ type: REQUEST_REMOVE_CONTACT_FAILED, error });
  }
}

function* addContact(data) {
  data.action = 'addContact';
  const { groupId, phone, name, city, zipcode, setSubmitting, toggle, action } = data;
  setSubmitting(true);
  try {
    const res = yield Services.post(
      MANAGE_CONTACTS_SERVLET_URL,
      Querystring.stringify({
        action,
        groupId,
        phone,
        name,
        city,
        zipcode,
        deleteOld: false,
        optIn: true,
        deviceId: '',
      })
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string' && res.data.toLowerCase() === 'fail') {
        showError(i18n.t('contact:error_add_contact'));
        setSubmitting(false);
      } else {
        Notification(
          'success',
          i18n.t('contact:added_contact_successfully'),
          '',
          TIME_OUT_CLOSE_TOAST,
          () => {}
        );
        setSubmitting(false);
        yield put({ type: REQUEST_ADD_CONTACT_SUCCESS, data: res.data });
      }
    }
  } catch (error) {
    showError(error);
    toggle();
    setSubmitting(false);
    yield put({ type: REQUEST_ADD_CONTACT_FAILED, error });
  }
}

function* getContactToEdit(data) {
  data.action = 'editContact';
  const { phone, groupId, action } = data;
  try {
    const body = Querystring.stringify({
      action,
      phone,
      groupId,
    });
    const res = yield Services.post(MANAGE_CONTACTS_SERVLET_URL, body);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object' && res.data) {
        yield put({ type: REQUEST_GET_EDIT_CONTACT_SUCCESS, data: res.data });
      } else {
        showError(i18n.t('contact:error_get_contact_edit'));
        yield put({
          type: REQUEST_GET_EDIT_CONTACT_FAILED,
          error: i18n.t('contact:error_get_contact_edit'),
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_GET_EDIT_CONTACT_FAILED, error });
  }
}

/* README: Flow: -> user start scrub -> call startScrub() -> checkScrub() -> getAllLandLine() -> re-call checkScrub()
(recursive) ... -> until not found progress id -> stop;
**/

function* startScrub(data) {
  const { groupId, callerIdLookup, toggle, callbacks } = data;
  try {
    const res = yield Services.post(
      START_LINE_CHECK_URL,
      Querystring.stringify({
        callerIdLookup,
        groupId,
      })
    );
    if (isResponseSuccess(res.status)) {
      const msgError = res?.data?.error;
      if (msgError) {
        showError(msgError);
        yield put({
          type: REQUEST_SCRUB_CONTACT_FAILED,
          error: msgError,
        });
        return;
      }

      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_SCRUB_CONTACT_SUCCESS,
          data: res.data.progressId,
        });
        yield put({ type: REQUEST_CHECK_SCRUB, groupId, isFirstLoad: false });
        callbacks && callbacks.onSuccess();
        toggle();
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_SCRUB_CONTACT_FAILED, error });
  }
}

function* checkScrub(data) {
  const { groupId, callbacks } = data;
  try {
    const res = yield Services.get(`${GET_LANDLINE_CHECK_STATUS_URL}?groupId=${groupId}`);

    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        callbacks && callbacks.onSuccess(res.data);
        yield delay(2000);
        yield checkScrub({ groupId, isFirstLoad: false, callbacks });
      } else {
        //* Check scrub complete
        callbacks && callbacks.onComplete();
        yield recheckStatusImportingScrubbing({ groupId });
        yield put({ type: REQUEST_CHECK_SCRUB_CANCEL, groupId });
      }
    }
  } catch (error) {
    showError(error);
  }
}

function* cancelScrub(data) {
  const { processId, toggleScrubDialogRoot, groupId } = data;
  try {
    const res = yield Services.post(
      CANCEL_LANDLINE_URL,
      Querystring.stringify({
        processId,
      })
    );
    if (isResponseSuccess(res.status)) {
      yield put({ type: REQUEST_CANCEL_LANDLINE_SUCCESS, groupId });
      Notification(
        'success',
        i18n.t('contact:canceled_scrub_successfully'),
        '',
        TIME_OUT_CLOSE_TOAST
      );
      toggleScrubDialogRoot();
    }
  } catch (error) {
    toggleScrubDialogRoot();
    showError(error);
    yield put({ type: REQUEST_CANCEL_LANDLINE_FAILED, error });
  }
}

function* removeGroup(data) {
  data.action = 'removeGroups';
  const {
    action,
    removeAll,
    deleteAutoReply,
    groupSeleted,
    setSubmitting,
    toggle,
    setGroupSelected,
  } = data;
  try {
    setSubmitting(true);
    const urlPost = `${MANAGE_CONTACTS_SERVLET_URL}?action=${action}&deviceId=&removeGroupFromAllGroups=${removeAll}&isRemoveAR=${deleteAutoReply}&ids=${convertListToParamString(
      groupSeleted
    )}`;
    const res = yield Services.post(urlPost);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (checkIsContactInProcessing(res.data)) {
          setSubmitting(false);
          showError(res.data);
          yield put({ type: REQUEST_REMOVE_GROUP_FAILED, error: message });
          return;
        }

        if (message === 'success') {
          setSubmitting(false);
          Notification(
            'success',
            i18n.t('contact:remove_group_successfully'),
            '',
            TIME_OUT_CLOSE_TOAST
          );
          toggle();
          setGroupSelected([]);
          yield put({ type: REQUEST_REMOVE_GROUP_SUCCESS, groupSeleted });
          return;
        }

        if (message === 'fail') {
          setSubmitting(false);
          showError(i18n.t('contact:error_remove_group'));
          yield put({
            type: REQUEST_REMOVE_GROUP_FAILED,
            error: i18n.t('contact:error_remove_group'),
          });
          return;
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_REMOVE_GROUP_FAILED, error });
    toggle();
  }
}

function* importListContact(data) {
  const { file, groupId, toggle, setShowProgress } = data;
  const formData = new FormData();
  formData.append('files[]', file);
  try {
    const res = yield Services.post(
      `${IMPORT_CONTACT_URL}?groupId=${groupId}&deviceId=&deleteOld=false&optIn=true`,
      formData
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        const resGetStatus = yield Services.get(
          `${IMPORT_FILE_STATUS_URL}?processId=${res.data.processId}`
        );
        if (isResponseSuccess(resGetStatus.status)) {
          if (typeof resGetStatus.data === 'object') {
            setShowProgress(true);
            const { completed } = resGetStatus.data;
            if (completed) {
              yield put({
                type: REQUEST_IMPORT_LIST_CONTACT_SUCCESS,
                processIdImport: res.data.processId,
                itemRunningImport: resGetStatus.data,
              });
            } else {
              yield put({
                type: REQUEST_IMPORT_LIST_CONTACT_SUCCESS,
                processIdImport: res.data.processId,
                itemRunningImport: resGetStatus.data,
              });
            }
          }
        }
      }
      toggle();
    }
    toggle();
  } catch (error) {
    toggle();
    showError(error);
    yield put({ type: REQUEST_IMPORT_LIST_CONTACT_FAILED, error });
  }
}

function* getProcessIdImport(data) {
  const { groupId, callbacks } = data;
  try {
    const res = yield Services.get(GET_ALL_RUNNING_CONTACT_IMPORT_URL);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        if (res.data.length > 0) {
          const item = res.data.find((el) => el.status.groupId === groupId);
          if (item) {
            yield put({
              type: REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS,
              data: item.processId,
            });
            callbacks && callbacks.onSuccess(item?.processId, item?.status || {});
            return item?.processId || '';
          }
        } else {
          yield put({
            type: REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS,
            data: null,
          });
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_GET_PROCESS_ID_IMPORT_FAILED, error });
  }
}

function* checkingStatusImport(data) {
  try {
    const { groupId, onImportComplete = () => {}, onWatchProgress = () => {} } = data;

    const resGetStatus = yield Services.get(`${IMPORT_FILE_STATUS_URL}?groupId=${groupId}`);
    if (isResponseSuccess(resGetStatus.status)) {
      if (typeof resGetStatus.data === 'object') {
        const { status, completed } = resGetStatus.data;

        //* If import successfully
        if (completed) {
          yield recheckStatusImportingScrubbing({ groupId });
          onImportComplete && onImportComplete();
          onWatchProgress && onWatchProgress(resGetStatus.data);
          yield put({
            type: REQUEST_CHECK_STATUS_IMPORT_SUCCESS,
            data: resGetStatus.data,
            header: resGetStatus?.data?.header,
            isImporting: false,
          });
        } else {
          onWatchProgress && onWatchProgress(resGetStatus.data);
          yield put({
            type: REQUEST_CHECK_STATUS_IMPORT_SUCCESS,
            data: resGetStatus.data,
            isImporting: true,
            header: resGetStatus?.data?.header,
          });

          if (isProcessingImportFile(status)) {
            yield delay(2000);
            yield checkStatusImport({ ...data });
          }
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_CHECK_STATUS_IMPORT_FAILED, error });
  }
}

function* checkStatusImport(data) {
  yield race([
    call(checkingStatusImport, data),
    take(REQUEST_CANCEL_IMPORT),
    take(typeUnmounted(components.contactDetail)),
  ]);
}

function* cancelImport(data) {
  const { groupId, toggleScrubDialogRoot, callbacks } = data;
  try {
    const processId = yield getProcessIdImport({ groupId });
    if (processId) {
      const res = yield Services.post(
        CANCEL_IMPORT_URL,
        Querystring.stringify({
          processId,
        })
      );
      if (isResponseSuccess(res.status)) {
        yield recheckStatusImportingScrubbing({ groupId });
        yield put({ type: REQUEST_CANCEL_IMPORT_SUCCESS });
        Notification(
          'success',
          i18n.t('contact:canceled_import_successfully'),
          '',
          TIME_OUT_CLOSE_TOAST
        );
        toggleScrubDialogRoot();
        callbacks && callbacks.onSuccess();
      }
    }
  } catch (error) {
    toggleScrubDialogRoot();
    showError(error);
    yield put({ type: REQUEST_CANCEL_IMPORT_FAILED, error });
  }
}

function* clear() {
  yield put({ type: REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS });
}

function* deleteByCarrier(data) {
  data.action = 'deleteContactByCarrier';
  const { action, carrier, groupId, setSubmitting, toggle } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(
      MANAGE_CONTACTS_SERVLET_URL,
      Querystring.stringify({
        action,
        carrier,
        groupId,
      })
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (checkIsContactInProcessing(res.data)) {
          setSubmitting(false);
          showError(res.data);
          yield put({
            type: REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED,
            error: res.data,
          });
          toggle();
          return;
        }

        if (message === 'success') {
          // Re-get Data
          const responseTotal = yield Services.post(
            MANAGE_CONTACTS_SERVLET_URL,
            Querystring.stringify({
              action: 'totalContact',
              groupId,
            })
          );

          setSubmitting(false);
          Notification('success', i18n.t('contact:delete_successfully'), '', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS,
            total: responseTotal.data,
            carrier,
          });
          toggle();
        } else {
          setSubmitting(false);
          showError(message);
          yield put({
            type: REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED,
            error: message,
          });
          toggle();
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED, error });
    toggle();
  }
}

function* uploadListContact(data) {
  const { file, groupId, delimiter, callbacks } = data;
  if (bytesToMegaBytes(file.size) > MAXIMUM_SIZE_UPLOAD) {
    Notification('warning', i18n.t('contact:limit_size_upload'), TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPLOAD_LIST_CONTACT_FAILED });
    return;
  }

  const formData = new FormData();
  formData.append('files[]', file);
  try {
    const res = yield Services.post(
      `${UPLOAD_CONTACT_URL}?groupId=${groupId}&delimiter=${delimiter}`,
      formData
    );
    if (isResponseSuccess(res.status) && res.data) {
      yield recheckStatusImportingScrubbing({ groupId });
      const previewLine = yield getPreviewLine({ groupId });
      if (previewLine) {
        yield put({
          type: REQUEST_UPLOAD_LIST_CONTACT_SUCCESS,
          data: res.data,
        });
        callbacks && callbacks.onSuccess(res?.data || {}, previewLine);
      }
    } else {
      showError(res?.data?.reason);
      yield put({ type: REQUEST_UPLOAD_LIST_CONTACT_FAILED });
      callbacks && callbacks.onFailed();
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_UPLOAD_LIST_CONTACT_FAILED, error });
    callbacks && callbacks.onFailed();
  }
}

function* getPreviewLine(data) {
  const { groupId, callbacks } = data;
  try {
    const res = yield Services.get(`${PREVIEW_LINE_URL}?groupId=${groupId}`);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        callbacks && callbacks.onSuccess(res?.data || []);
        yield put({ type: REQUEST_GET_PREVIEW_LINE_SUCCESS, data: res.data });
        return res?.data || [];
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_GET_PREVIEW_LINE_FAILED, error });
  }
}

function* getHeaderField() {
  try {
    const res = yield Services.get(`${MANAGE_CONTACTS_SERVLET_URL}?action=loadContactFields`);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        const headerField = res?.data.filter((el) => !ContactFieldsShouldHided.includes(el.value));
        yield put({ type: REQUEST_HEADER_FIELD_SUCCESS, data: headerField || [] });
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_HEADER_FIELD_FAILED, error });
  }
}

function* deleteFile(data) {
  const { groupId, callbacks } = data;
  try {
    const res = yield Services.get(`${DELETE_PREVIEW_FILE_URL}?groupId=${groupId}`);
    if (isResponseSuccess(res.status)) {
      yield recheckStatusImportingScrubbing({ groupId });
      if (typeof res.data === 'boolean' && res.data) {
        yield put({ type: types.REQUEST_CLEAR_IMPORT_CONTACT });
        yield put({ type: REQUEST_DELETE_FILE_SUCCESS, data: res.data });
        callbacks && callbacks.onSuccess();
      }
    }
  } catch (error) {
    callbacks && callbacks.onFailed();
    showError(error);
    yield put({ type: REQUEST_DELETE_FILE_FAILED, error });
  }
}

function* importFileFromStorage(data) {
  const { groupId, header, callbacks } = data;
  const { onImportFileComplete = () => {}, onFailed } = callbacks || {};

  let url = `${IMPORT_FROM_STORAGE_URL}?groupId=${groupId}`;
  if (header != '') {
    url += `&header=${header}`;
  }
  try {
    const res = yield Services.post(url);
    if (isResponseSuccess(res.status)) {
      yield recheckStatusImportingScrubbing({ groupId });
      if (typeof res.data === 'object') {
        if (isString(res?.data?.reason)) {
          if (checkIsContactInProcessing(res?.data?.reason)) {
            showError(res?.data?.reason);
            yield put({
              type: REQUEST_IMPORT_FROM_STORAGE_FAILED,
              error: res?.data?.reason,
            });
          }
          onFailed && onFailed(res?.data?.reason);
          return;
        }

        yield put({
          type: REQUEST_IMPORT_FROM_STORAGE_SUCCESS,
          processIdImport: res.data.processId,
          startImporting: true,
          itemRunningImport: {},
          header: res?.data?.header,
        });
        onImportFileComplete();
        return;
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_IMPORT_FROM_STORAGE_FAILED, error });
    onFailed && onFailed(error);
  }
}

function* mergeContactServlet(data) {
  const {
    setGroupSelected,
    groupSeleted,
    groupNames,
    setSubmitting,
    toggle,
    deleteOrigin,
    filters = {},
    typeContact,
  } = data;
  setSubmitting(true);
  try {
    const requestMerge = yield ManageContactServices.mergeContact({
      groupNames,
      groupSeleted,
      deleteOrigin,
    });
    if (isResponseSuccess(requestMerge.status)) {
      if (isString(requestMerge?.data?.error)) {
        if (checkIsContactInProcessing(requestMerge?.data?.error)) {
          setSubmitting(false);
          showError(requestMerge?.data?.error);
          yield put({
            type: REQUEST_MERGE_GROUPS_FAILED,
            error: requestMerge?.data?.error,
          });
        }
        return;
      }

      yield refetchData({ isSendPage: false, filters, typeContact });
      setSubmitting(false);
      setGroupSelected([]);
      toggle();
      Notification(
        'success',
        i18n.t('contact:merge_successfully'),
        'Success',
        TIME_OUT_CLOSE_TOAST
      );
      yield put({ type: REQUEST_MERGE_GROUPS_SUCCESS });
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_MERGE_GROUPS_FAILED, error });
  }
}

function* splitContactServlet(data) {
  const {
    setGroupSelected,
    groupId,
    setSubmitting,
    toggle,
    size,
    deleteOriginalGroup,
    filters = {},
    typeContact,
    groupName,
  } = data;
  setSubmitting(true);
  try {
    const requestSplit = yield Services.post(
      `${SPLIT_GROUP_URL}?groupName=${groupName}&groupId=${groupId}&size=${size}&deleteOriginalGroup=${deleteOriginalGroup}`
    );
    if (isResponseSuccess(requestSplit.status)) {
      if (isString(requestSplit?.data?.error)) {
        if (checkIsContactInProcessing(requestSplit?.data?.error)) {
          setSubmitting(false);
          showError(requestSplit?.data?.error);
          yield put({
            type: REQUEST_SPLIT_GROUPS_FAILED,
            error: requestSplit?.data?.error,
          });
          return;
        }

        setSubmitting(false);
        showError(requestSplit?.data?.error);
        yield put({
          type: REQUEST_SPLIT_GROUPS_FAILED,
          error: requestSplit?.data?.error,
        });
        return;
      }

      yield refetchData({ isSendPage: false, typeContact, filters });
      setSubmitting(false);
      setGroupSelected([]);
      toggle();
      Notification(
        'success',
        i18n.t('contact:split_successfully'),
        'Success',
        TIME_OUT_CLOSE_TOAST
      );
      yield put({ type: REQUEST_SPLIT_GROUPS_SUCCESS });
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_SPLIT_GROUPS_FAILED, error });
  }
}

function* searchContactServlet(data) {
  const { groupId } = data;

  const filtersParsed = ContactGroupModel.parseRequestSearchContact(data);
  try {
    const reqSearch = ManageContactServices.searchContact({ groupId, filters: filtersParsed });
    const reqTotal = ManageContactServices.totalContactV2({
      groupId,
      target: parseTargetForSearchContact(filtersParsed?.target || []),
    });
    const reqAll = yield Promise.all([reqTotal, reqSearch]);

    const [resTotal, resSearch] = reqAll;
    const total = resTotal.data;
    const contacts = resSearch.data;
    yield put({
      type: REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS,
      payload: { contacts: contacts.contacts, total },
    });
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_SEARCH_CONTACT_SERVLET_FAILED, error });
  }
}

function* changeNameContact(data) {
  const { callbacks, name, groupId } = data;
  try {
    const res = yield ContactServices.renameContact({ groupId, name });
    if (typeof res.data === 'string' && res.data.toLowerCase() === 'success') {
      notifySuccess(i18n.t('contact:change_name_successfully'), 'Success');
      yield put({ type: REQUEST_CHANGE_NAME_CONTACT_SUCCESS, groupId, name });
      callbacks.onSuccess();
    } else {
      showError(res.data);
      callbacks.onFailed(res.data);
      yield put({ type: REQUEST_CHANGE_NAME_CONTACT_FAILED, error: res.data });
    }
  } catch (error) {
    showError(error);
    callbacks.onFailed();
    yield put({ type: REQUEST_CHANGE_NAME_CONTACT_FAILED, error });
  }
}

function* getDataConsuming(data) {
  const { groupId } = data;
  try {
    const consumingAvailable = yield select(
      (state) => state.contactServletReducer.dataConsuming.consumingAvailable
    );
    const contactDetailMounted = yield select(
      (state) => state.stateComponent[typeMounted(components.contactDetail)]
    );
    const { response, cancelled } = yield race({
      response: ContactServices.getDataConsuming({ groupId }),
      cancelled: take(typeUnmounted(components.contactDetail)),
    });

    if (cancelled || !contactDetailMounted) {
      return;
    }

    const { data } = response;
    if (data) {
      //* if consuming is happening
      const { created, groupId, processed, total, userId } = data;
      yield put({
        type: REQUEST_GET_DATA_CONSUMING_SUCCESS,
        consumingAvailable: true,
        created,
        groupId,
        processed,
        total,
        userId,
      });
      yield delay(2000);
      yield getDataConsuming({ groupId });
      return;
    }

    //* if consuming is success
    if (consumingAvailable) {
      //* check if data consuming just completed
      notifySuccess(i18n.t('contact:data_consuming_successfully'), 'Success');
    }
    yield put({
      type: REQUEST_GET_DATA_CONSUMING_SUCCESS,
      consumingAvailable: false,
    });
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_GET_DATA_CONSUMING_FAILED,
      consumingAvailable: false,
      error,
    });
  }
}

function* startDataConsuming(data) {
  const { groupId, callbacks } = data;
  try {
    const { response, cancelled } = yield race({
      response: ContactServices.startDataConsuming({ groupId }),
      cancelled: take(typeUnmounted(components.contactDetail)),
    });

    if (cancelled) {
      return;
    }

    const { data } = response;
    if (isString(data?.error)) {
      if (checkIsContactInProcessing(data?.error)) {
        showError(data?.error);
        yield put({
          type: REQUEST_START_DATA_CONSUMING_FAILED,
          error: data?.error,
        });
      }
      return;
    }

    if (data) {
      notifySuccess(i18n.t('contact:start_consuming'), 'Success');
      yield put({ type: REQUEST_START_DATA_CONSUMING_SUCCESS });
      yield put({ type: REQUEST_GET_DATA_CONSUMING, groupId });
      callbacks && callbacks.onSuccess();
      return;
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_START_DATA_CONSUMING_FAILED, error });
  }
}

function* getDataRefreshing(data) {
  const { groupId } = data;
  try {
    const refreshingAvailable = yield select(
      (state) => state.contactServletReducer.dataRefreshing.refreshingAvailable
    );
    const contactDetailMounted = yield select(
      (state) => state.stateComponent[typeMounted(components.contactDetail)]
    );
    const { response, cancelled } = yield race({
      response: ContactServices.getDataRefreshing({ groupId }),
      cancelled: take(typeUnmounted(components.contactDetail)),
    });

    if (cancelled || !contactDetailMounted) {
      return;
    }

    const { data } = response;
    if (data) {
      //* if consuming is happening
      const { created, groupId, processed, total, userId } = data;
      yield put({
        type: REQUEST_GET_DATA_REFRESHING_SUCCESS,
        refreshingAvailable: true,
        created,
        groupId,
        processed,
        total,
        userId,
      });
      yield delay(2000);
      yield getDataRefreshing({ groupId });
      return;
    }

    //* if refreshing is success
    if (refreshingAvailable) {
      //* check if data consuming just completed
      notifySuccess(i18n.t('contact:data_refreshing_successfully'), 'Success');
    }
    yield put({
      type: REQUEST_GET_DATA_REFRESHING_SUCCESS,
      refreshingAvailable: false,
    });
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_GET_DATA_REFRESHING_FAILED,
      refreshingAvailable: false,
      error,
    });
  }
}

function* startDataRefreshing(data) {
  const { groupId, callbacks } = data;
  try {
    const { response, cancelled } = yield race({
      response: ContactServices.startDataRefreshing({ groupId }),
      cancelled: take(typeUnmounted(components.contactDetail)),
    });

    if (cancelled) {
      return;
    }

    const { data } = response;
    if (isString(data?.error)) {
      if (checkIsContactInProcessing(data?.error)) {
        showError(data?.error);
        yield put({
          type: REQUEST_START_DATA_REFRESHING_FAILED,
          error: data?.error,
        });
      }
      return;
    }

    if (data) {
      notifySuccess(i18n.t('contact:start_refreshing'), 'Success');
      yield put({ type: REQUEST_START_DATA_REFRESHING_SUCCESS });
      yield put({ type: REQUEST_GET_DATA_REFRESHING, groupId });
      callbacks && callbacks.onSuccess();
      return;
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_START_DATA_REFRESHING_FAILED, error });
  }
}

function* saveContactGroupLeadFilter({ groupId = '', bodyRequest = '', callbacks }) {
  try {
    const response = yield ContactServices.saveContactGroupLeadFilter({
      groupId,
      ...bodyRequest,
    });

    notifySuccess('Update lead filter successfully!');
    yield put({
      type: types.REQUEST_SAVE_LEAD_FILTER_SUCCESS,
      nextLeadFilter: response?.data?.metadata?.leadFilter || [],
    });
    callbacks && callbacks.onSuccess(response);
  } catch (error) {
    yield put({ type: types.REQUEST_SAVE_LEAD_FILTER_FAILED, error });
    showError(error);
    callbacks && callbacks.onFailed(error);
  }
}

function* setLeadCallbackLink(data) {
  const { callbacks, groupId, url } = data || {};
  try {
    const response = yield ContactServices.setCallbackLink({ groupId, url });
    yield put({
      type: REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS,
      leadCallback: response?.data?.metadata?.leadCallback || '',
    });
    notifySuccess('Set lead callback link successfully!');
    callbacks && callbacks.onSuccess(response);
  } catch (error) {
    yield put({ type: REQUEST_SET_LEAD_CALLBACK_LINK_FAILED, error });
    showError(error);
    callbacks && callbacks.onFailed(error);
  }
}

//! Watcher
export default function* watchGetAPIFunction() {
  yield takeLatest(types.REQUEST_SAVE_LEAD_FILTER, saveContactGroupLeadFilter);
  yield takeLatest(
    REQUEST_API_MANAGE_CONTACT_SERVLET,
    handleWorker({
      handler: getManageContactServlet,
      cancelled: take([typeUnmounted(components.contacts)]),
    })
  );

  yield takeLatest(
    REQUEST_API_CONTACT_SERVLET,
    handleWorker({
      handler: getContactServlet,
      cancelled: take([typeUnmounted(components.contactDetail)]),
    })
  );

  yield takeLatest(
    REQUEST_LOAD_MORE_CONTACT,
    handleWorker({
      handler: loadMoreManageContactServlet,
      cancelled: take([typeUnmounted(components.contacts), REQUEST_API_MANAGE_CONTACT_SERVLET]),
    })
  );
  yield takeLatest(REQUEST_API_GET_CONTACT_BELONG_TO, getContactBelongTo);
  yield takeEvery(REQUEST_CLEAR_CONTACT_SERVLET, clear);
  yield takeLatest(REQUEST_ADD_CONTACT, addContact);
  yield takeEvery(REQUEST_REMOVE_CONTACT, removeContact);
  yield takeLatest(REQUEST_GET_EDIT_CONTACT, getContactToEdit);

  yield takeLatest(REQUEST_REMOVE_GROUP, removeGroup);
  yield takeLatest(REQUEST_CANCEL_LANDLINE, cancelScrub);
  yield takeLatest(REQUEST_IMPORT_LIST_CONTACT, importListContact);
  yield takeEvery(REQUEST_GET_PROCESS_ID_IMPORT, getProcessIdImport);
  yield takeLatest(REQUEST_DELETE_CONTACT_BY_CARRIER, deleteByCarrier);
  yield takeLatest(REQUEST_UPLOAD_LIST_CONTACT, uploadListContact);
  yield takeLatest(REQUEST_GET_PREVIEW_LINE, getPreviewLine);
  yield takeLatest(REQUEST_HEADER_FIELD, getHeaderField);
  yield takeLatest(REQUEST_DELETE_FILE, deleteFile);
  yield takeLatest(REQUEST_MERGE_GROUPS, mergeContactServlet);
  yield takeLatest(REQUEST_SPLIT_GROUPS, splitContactServlet);
  yield takeLatest(REQUEST_SEARCH_CONTACT_SERVLET, searchContactServlet);
  yield takeEvery(REQUEST_CHANGE_NAME_CONTACT, changeNameContact);
  yield takeLatest(REQUEST_SET_LEAD_CALLBACK_LINK, setLeadCallbackLink);

  //* Scrubbing
  yield takeEvery(REQUEST_SCRUB_CONTACT, startScrub);
  yield takeLatest(
    REQUEST_CHECK_SCRUB,
    handleWorker({
      handler: checkScrub,
      cancelled: take([typeUnmounted(components.contactDetail)]),
    })
  );

  //* Data consuming
  yield takeLatest(REQUEST_START_DATA_CONSUMING, startDataConsuming);
  yield takeLatest(
    REQUEST_GET_DATA_CONSUMING,
    handleWorker({
      handler: getDataConsuming,
      cancelled: take([typeUnmounted(components.contactDetail)]),
    })
  );

  //* Data refreshing
  yield takeLatest(REQUEST_START_DATA_REFRESHING, startDataRefreshing);
  yield takeLatest(
    REQUEST_GET_DATA_REFRESHING,
    handleWorker({
      handler: getDataRefreshing,
      cancelled: take([typeUnmounted(components.contactDetail)]),
    })
  );

  //* Importing
  yield takeLatest(REQUEST_IMPORT_FROM_STORAGE, importFileFromStorage);
  yield takeLatest(
    REQUEST_CHECK_STATUS_IMPORT,
    handleWorker({
      handler: checkStatusImport,
      cancelled: take([typeUnmounted(components.contactDetail)]),
    })
  );
  yield takeLatest(REQUEST_CANCEL_IMPORT, cancelImport);
}
